import '../scss/category.scss';

// import Swiper and modules styles
// import Swiper from 'swiper';
// import {Navigation} from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/navigation';

import menuModule from "./modules/menu.js";
import scrollUpModule from "./modules/scrollUpModule.js";
import footerModule from "./modules/footerModule.js";
import scrollSidebarModule from "./modules/scrollSidebarModule.js";

(function ($) {
    $(document).ready(function () {
        window.$ = jQuery;

        menuModule.init();
        scrollUpModule.init();
        scrollSidebarModule.init();
        footerModule.init();
    });

}(jQuery));



